import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { format, useDialogPluginComponent } from "quasar"
import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxBtnOutline from "src/components/button/SfxBtnOutline.vue"
import SfxEmptyPage from "src/components/empty/SfxEmptyPage.vue"
import { EmptyStates } from "src/util/constants/emptyStates"
import { MissingEntityType } from "src/util/enums/entityType"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogNoWorkspaces',
  props: {
  cancelButtonText: {
    type: String,
    default: () => {
      const { t } = useI18n()
      return format.capitalize(t("sfxButtons.btn_proceed"))
    },
  },

  confirmButtonText: {
    type: String,
    default: () => {
      const { t } = useI18n()
      return format.capitalize(t("sfxButtons.btn_log_me_out"))
    },
  },
},
  emits: [...useDialogPluginComponent.emits],
  setup(__props) {

const props = __props



//endregion

//region Variables

const { dialogRef, onDialogOK, onDialogCancel } = useDialogPluginComponent()

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createVNode(SfxEmptyPage, {
                missingEntity: _unref(EmptyStates).get(_unref(MissingEntityType).WORKSPACE_NOT_FOUND),
                error: "",
                "icon-color": "error"
              }, null, 8, ["missingEntity"])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, { class: "row justify-evenly q-pt-none q-px-md q-pb-md" }, {
            default: _withCtx(() => [
              _createVNode(SfxBtnOutline, {
                class: "col q-mr-sm",
                onClick: _unref(onDialogCancel),
                label: props.cancelButtonText
              }, null, 8, ["onClick", "label"]),
              _createVNode(SfxBtn, {
                class: "col q-ml-sm",
                onClick: _unref(onDialogOK),
                label: props.confirmButtonText
              }, null, 8, ["onClick", "label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})